import { render, staticRenderFns } from "./DashboardBox.vue?vue&type=template&id=1d25b63a&scoped=true&"
import script from "./DashboardBox.vue?vue&type=script&lang=js&"
export * from "./DashboardBox.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBox.vue?vue&type=style&index=0&id=1d25b63a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d25b63a",
  null
  
)

export default component.exports